import { getRolesWithPermission, type PermissionContext } from 'shared/constants/permissions'

/**
 * Prepended to a tool's description when the current user's role lacks the permission.
 *
 * Names the roles, not the permission: roles are what the user sees in workspace settings, so they
 * are what the agent can act on.
 */
export const buildMissingPermissionDescriptionPrefix = ({ memberRole, permission }: PermissionContext): string =>
  `THIS TOOL IS DISABLED AND WON'T WORK IF CALLED. IT REQUIRES ONE OF THESE ROLES: ${getRolesWithPermission(
    permission
  ).join(', ')}. THE USER ONLY HAS ${memberRole}.`

/**
 * Returned instead of running the handler when the user's role lacks the permission.
 *
 * Returned rather than thrown: a thrown handler sets `handlerResult.error` in `@copilotkit/core`,
 * which suppresses the follow-up run — leaving the run with no terminal event — and raises a
 * user-facing error toast.
 */
export const buildMissingPermissionToolResult = ({
  memberRole,
  permission
}: PermissionContext): { success: false; message: string } => ({
  success: false,
  message: `The user has the workspace role "${memberRole}", which is not enough to perform this action. It requires one of these roles: ${getRolesWithPermission(
    permission
  ).join(', ')}.`
})
